import React from 'react';

export const Button = ({ children, variant = 'primary', className = '', disabled, ...props }) => {
  const baseStyle = "inline-flex items-center justify-center px-6 py-2.5 rounded-lg font-medium transition-all duration-200 text-sm";
  
  const variants = {
    primary: "bg-brand-accent text-white hover:bg-brand-accentHover disabled:bg-brand-border disabled:text-brand-muted disabled:cursor-not-allowed shadow-sm",
    secondary: "bg-brand-light text-brand-text hover:bg-brand-border disabled:opacity-50",
    outline: "border-2 border-brand-border text-brand-text hover:border-brand-accent hover:text-brand-accent disabled:opacity-50",
    ghost: "text-brand-muted hover:text-brand-text hover:bg-brand-light"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};